module.exports = __webpack_public_path__ + "static/34gde-eabc6eb869789ca79f30f243c6c9a50c.gif";